import React from "react"; 
import projects from '../resource.json';

class Projects extends React.Component {
    render() {
        return (
            <div className="projects">
                <h1 className="projects-heading">Projects</h1>
                <div className="projects-container">
                    {projects.map((project) => {
                        return (
                            <div className="project-card">
                                <img src={project.image} alt="project" className="project-image" />
                                <div className="project-details">
                                    <h2 className="project-title">{project.title}</h2>
                                    <p className="project-description">{project.description}</p>
                                    <p className="project-technologies">{project.technologies}</p>
                                    <div className="project-links">
                                        <a href={project.github} className="project-link">Github</a>
                                        <span>&nbsp; &nbsp;</span>
                                        <a href={project.url} className="project-link">Link</a>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}

export default Projects;